import React from "react";
import PropTypes from 'prop-types';

const ListeClassement = ({ children}) => {
    return (
        <div className="space-y-2">
            <div className="space-y-3">
                {children}
            </div>
        </div>
    );
};

ListeClassement.propTypes = {
    children: PropTypes.node,
    titre: PropTypes.string,
};

export default ListeClassement;

